import { useQueuedModal } from '@/hooks/useQueuedModal';
import { scribeLayoutCsatAnalyticsPorts } from '@/models/analytics/features/trackScribeLayoutCsatAnalytics';
import { CsatPopoverFormFields, ScribeLayoutCsatPopover } from '@heidi/growth';
import { ModalId } from '@heidi/schema/ml-scribe';

/**
 * The app half of the scribe-layout CSAT popover.
 *
 * The queue registration stays here — `@heidi/growth` renders the survey and
 * never decides when it shows. The shared CSAT fields cross as a component slot
 * and the two emits as injected seams.
 */
export const ScribeLayoutCsatPopoverHost = () => {
  const { isOpen, handleClose } = useQueuedModal(
    ModalId.T5_CUSTOM_AUDIENCE_SCRIBE_LAYOUT_CSAT_POPOVER
  );

  return (
    <ScribeLayoutCsatPopover
      isOpen={isOpen}
      onClose={handleClose}
      formFields={CsatPopoverFormFields}
      analytics={scribeLayoutCsatAnalyticsPorts}
    />
  );
};

ScribeLayoutCsatPopoverHost.displayName = 'ScribeLayoutCsatPopoverHost';
